/*
 * @Author: cmchiu
 * @Date: 2023-03-21 15:02:17
 * @LastEditTime: 2023-03-21 15:26:35
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \IACMP\IACMP_Client\src\router\routes.js
 *
 */
import Layout from '@/layout'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
    {
        path: '/',
        component: Layout,
        name: '_home',
        redirect: '/home',
        children: [
            {
                path: 'home',
                name: 'Home',
                component: () => import('@/views/Home'),
                meta: { title: '學習市集', icon: 'el-icon-s-home' },
            },
        ],
    },
    /* {
        path: '/',
        component: Layout,
        redirect: '/coursebook',
        children: [
            {
                path: 'coursebook',
                name: 'CourseBook',
                component: () => import('@/views/CourseBook'),
                meta: { title: '課程預約' },
            },
        ],
    }, */
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = []

export default [...constantRoutes, ...asyncRoutes]
